<template>
    <b-modal :id="id" ref="sampleConfirmationModal" centered
             v-bind:modal-class="[{ busy: submitProcessing}, 'opacity-transition']">
        <pb-spinner v-if="submitProcessing"></pb-spinner>
        <template #modal-header="{ close }">
            <b-row class="align-items-center">
                <b-col md="3">
                    <img v-if="article" class="header-img" :src="imageResource(article.webImage || article.image, 100)"
                         alt="image"/>
                </b-col>
                <b-col>
                    <h4 class="m-0 px-1">{{title}}&nbsp;|&nbsp;{{variant.articleColor.customerValue || variant.articleColor.value }}&nbsp;|&nbsp;{{variant.articleSize.customerValue || variant.articleSize.value}}</h4>
                </b-col>
            </b-row>
        </template>
        <template slot="modal-footer">
            <b-button variant="secondary" @click="$refs.sampleConfirmationModal.hide()">
                CANCEL
            </b-button>
            <pb-btn variant="secondary" v-on:click.native="onSubmit(null,'sample-overview')">
                SAVE & SHOW SAMPLES
            </pb-btn>
            or
            <pb-btn variant="primary"
                    v-on:click.native="onSubmit">
                SAVE
            </pb-btn>
        </template>
        <b-container>
            <b-row>
                <b-col v-if="article">
                    <b-form @submit="onSubmit">
                        <b-row>
                            <b-col md="4" class="text-right">
                                <label for="comment">Optional information:</label>
                            </b-col>
                            <b-col>
                                <b-form-textarea
                                        id="comment"
                                        name="comment"
                                        class="h-auto secondary"
                                        v-model.trim="formData.comment"
                                        rows="2"
                                        placeholder="Alternative finish or size, comment"
                                        no-resize
                                ></b-form-textarea>
                            </b-col>

                        </b-row>

                        <b-row class="mt-2">
                            <b-col md="4" class="text-right">
                                <label for="amount">Amount:</label>
                            </b-col>
                            <b-col  md="4">
                                <b-form-spinbutton
                                        id="amount"

                                        v-model="formData.amount"
                                        min="1"
                                        class="secondary"
                                        max="5"
                                        step="1"
                                ></b-form-spinbutton>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col md="4">
                            </b-col>
                            <b-col  >
                                <b-form-checkbox class="secondary mt-2" v-model="formData.hideSamplePopup">Hide popup
                                    for current session
                                </b-form-checkbox>
                            </b-col>
                        </b-row>

                    </b-form>
                </b-col>
                <b-col v-else>
                    There is no article selected.
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>

<script>

    import {mapActions} from "vuex";

    function initialData() {
        return {
            submitSuccess: false,
            submitProcessing: false,
            submitError: null,
            localSampleItem: null,
            article: null,
            variant: null,
            formData: {
                comment: null,
                amount: 1,
                hideSamplePopup: null
            }
        }
    }

    export default {
        name: 'sample-confirmation.modal',
        props: {
            id: String,
            category: Object
        },
        data() {
            return {
                ...initialData()
            };
        },
        methods: {
            ...mapActions('sample', ['addSample', 'fetchSampleList']),
            show(sampleRequest) {
                Object.assign(this.$data, initialData());
                this.article = sampleRequest.article;
                this.variant = sampleRequest.variant;
                this.$refs.sampleConfirmationModal.show();

            },
            onSubmit(evt, target) {
                this.submitProcessing = true;
                if (this.formData.hideSamplePopup) {
                    window.$cookies.set('hideSamplePopup', 1, '90D');
                }
                this.addSample({
                    item: {
                        comment: this.formData.comment,
                        articleId: this.article.id,
                        categoryId: this.category.id,
                        variantId: this.variant.variationId,
                        amount: this.formData.amount
                    }
                }).then(() => {
                    this.$refs.sampleConfirmationModal.hide();
                    this.$bvToast.toast(`Successfully added the item to your sample request.`, this.$toastSuccess);
                    this.fetchSampleList();
                    if (target) {
                        this.$router.push({name: target});
                    }
                }).catch((error) => {
                    if (error && error.status === 400) {
                        this.$bvToast.toast(`Item was already added.`, this.$toastDanger);
                    } else {
                        this.$bvToast.toast(`Error adding item to your sample request.`, this.$toastDanger);
                    }
                }).finally(() => {
                    this.submitProcessing = false;
                });
            },
        },
        computed: {
            title: function () {
                return this.article ? `Request ${this.article.name}` : '';
            }
        }

    }
</script>

<style lang="scss" scoped>
    @import "~@shared/_assets/scss/constants";

    .header-img {
        max-height: 50px;
        flex: 1 0 0;
        width: 100%;
        height: 100%;
        margin: auto;
        -o-object-fit: contain;
        object-fit: contain;
    }

</style>